import React from 'react'
import { Button, Card, Container, Row } from 'react-bootstrap'
import './CardStyle.css'
import { useHistory } from 'react-router-dom'

const Postcard = ({ postId, title, imageUrl, date, author }) => {
  const shortenedDate = date && date.substring(0, 10)

  const history = useHistory()
  return (
    <Container>
      <Row></Row>
      <Card className="card-m mt-4" style={{ width: '100', margin: '9px' }}>
        <Card.Img
          className="img-fluid "
          variant="top"
          src={imageUrl && imageUrl.replace(/"([^"]+(?="))"/g, '$1')}
          alt={'image'}
        />
        <Card.Body>
          <Card.Title>
            {title} | {author}
          </Card.Title>
          <p className="date-style">Created on: {shortenedDate}</p>
          <Button
          className="read-button"
            onClick={() => history.push(`/post/${postId}`)}
          >
            Read more
          </Button>
        </Card.Body>
      </Card>
    </Container>
  )
}

export default Postcard
